<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else userSecurityQuestionFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="userSecurityQuestionFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #userSecurityQuestionFlexColumnTemplate>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
  <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
    <div *ngIf="isBrowserIE && media.isActive('lt-md'); else userSecurityQuestionMainFlexColumnTemplate">
      <ng-container *ngTemplateOutlet="userSecurityQuestionMainFlexColumnTemplate"></ng-container>
    </div>
  </div>
  <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #userSecurityQuestionMainFlexColumnTemplate>
  <div fxFlex="50%" fxHide.lt-md></div>
  <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px;">
    <div class="display-text normal-paragraph-spacing">
      <mat-card>
        <mat-card-content>
          <div fxLayout="column">
            <div *ngIf="isBrowserIE; else userSecurityQuestionFormFlexColumnTemplate">
              <ng-container *ngTemplateOutlet="userSecurityQuestionFormFlexColumnTemplate"></ng-container>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #userSecurityQuestionFormFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text primary-dark-color-important">
      <b><span i18n="@@user-security-question.form.title">user-security-question.form.title</span></b>
    </div>
    <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
    <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showSpinner">
      <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div class="display-text" *ngIf="!showSpinner">
      <form [formGroup]="userSecurityQuestionForm">
        <div fxLayout="column">
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
          >
            <b><span i18n="@@user-security-question.pre-message.1">user-security-question.pre-message.1</span></b>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
          >
            <b><span i18n="@@user-security-question.pre-message.2">user-security-question.pre-message.2</span></b>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
            <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
              <input
                matInput
                i18n-placeholder="@@user-security-question.form.username.placeholder"
                placeholder="user-security-question.form.username.placeholder"
                type="text"
                [value]="securityQuestionChange.userName"
                autocomplete="off"
                readonly
                disabled
              />
              <mat-icon matSuffix>done</mat-icon>
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
            <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
              <mat-select
                i18n-placeholder="@@user-security-question.form.security-question.label"
                placeholder="user-security-question.form.security-question.label"
                [formControl]="securityQuestionFormControl"
                autocomplete="off"
                required
              >
                <mat-option *ngFor="let item of securityQuestionsList" value="{{ item.securityQuestionId }}">{{
                  item.securityQuestion
                }}</mat-option>
              </mat-select>
              <mat-icon
                matSuffix
                class="tooltip-icon"
                matTooltip="{{ getToolTip('securityQuestion') }}"
                matTooltipPosition="after"
                matTooltipClass="tooltip-multi-line"
                >help_outline</mat-icon
              >
              <mat-error *ngIf="securityQuestionFormControl.hasError('required')" i18n="@@user-security-question.form.error.required"
                >user-security-question.form.error.required</mat-error
              >
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
            <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
              <input
                matInput
                i18n-placeholder="@@user-security-question.form.security-question-answer.placeholder"
                placeholder="user-security-question.form.security-question-answer.placeholder"
                type="text"
                [formControl]="securityQuestionAnswerFormControl"
                autocomplete="off"
                [maxlength]="fieldValidations.userRegistration.securityQuestionAnswerMaxLength"
                required
              />
              <mat-hint align="end"
                  i18n="@@user-security-question.form.hint.security-question-answer">user-security-question.form.hint.security-question-answer</mat-hint>
              <mat-error *ngIf="securityQuestionAnswerFormControl.hasError('required')" i18n="@@user-security-question.form.error.required"
                >user-security-question.form.error.required</mat-error
              >
            </mat-form-field>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing">
            <re-captcha formControlName="recaptchaFormControl" siteKey="{{ recaptchaSiteKey }}" required></re-captcha>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showSecurityQuestionError"
          >
            <b><span i18n="@@user-security-question.submit-message.error.1">user-security-question.submit-message.error.1</span></b>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            style="text-align: center;"
            class="display-text warning-color normal-paragraph-spacing"
            *ngIf="showSecurityQuestionError"
          >
            <b><span i18n="@@user-security-question.submit-message.error.2">user-security-question.submit-message.error.2</span></b>
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="center center"
            class="display-text normal-paragraph-spacing"
            *ngIf="!showSecurityQuestionSpinner"
          >
            <button
              mat-flat-button
              color="primary"
              (click)="submitSecurityQuestion()"
              i18n="@@user-security-question.form.submit-button.label"
              [disabled]="!submitEnabled()"
            >
              user-security-question.form.submit-button.label
            </button>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showSecurityQuestionSpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
